// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/styles/" + "styles" + "." + "4fb4507f963073784990" + ".css";
};